import Vue from 'vue'

export default new Vue()

export const EVENTS = {
  CONFIRM_MODAL_CONFIRM: 'confirm-modal-confirm',
  CONFIRM_MODAL_DISMISS: 'confirm-modal-dismiss'
}
